import React, { useState } from 'react'
import DashboardHeader from '../DashboardHeader/DashboardHeader'
import { Menu, MenuHandler, MenuItem, MenuList, Tooltip } from '@material-tailwind/react'
import { useNavigate } from 'react-router-dom'
import { CopyIcon2, CouponIcon, PencilIcon } from '../../Assets/AllSvg'
import { BsThreeDots } from 'react-icons/bs'
import { BiPlus } from 'react-icons/bi'
import { AiTwotoneDelete } from 'react-icons/ai'
import DeleteCouponModal from '../DeleteCouponModal/DeleteCouponModal'
import UpdateCouponDetailModal from '../UpdateCouponDetailModal/UpdateCouponDetailModal'
import AddPromoCodeModal from '../AddPromoCodeModal/AddPromoCodeModal'

const CouponDetails = () => {
    const [tab, setTab] = useState('customer')
    const [delCoupon, setDelCoupon] = useState(false)
    const [promoCode, setPromoCode] = useState(false)
    const [active, setActive] = useState(false)
    const [options, setOptions] = useState({
        metaData: false
    })

    const navigate = useNavigate()

    const handleAddMetadata = () => {
        setOptions({ ...options, metaData: !options.metaData })
    }

    const handleSetTab = (value) => {
        setTab(value)
    }

    const handleOpenDelCoupon = () => {
        setDelCoupon(true)
    }

    const handleOpenUpdateCoupon = () => {
        setActive(true)
    }

    const handleOpenPromoCode = () => {
        setPromoCode(true)
    }

    return (
        <div>
            <DashboardHeader />
            <div className="max-w-[1690px] mx-auto sm:p-[40px] p-[20px] w-full text-[#414552]">
                <div className="flex items-center justify-between">
                    <div className='flex items-center gap-2 text-[#687385] text-[13px] cursor-pointer' onClick={() => navigate(-1)}>
                        <button><CouponIcon className='w-[12px] h-[12px] fill-[#687385]' /></button>
                        <span className='font-medium'>COUPON</span>
                    </div>
                    <Tooltip className="bg-gray-800 text-white" content={
                        <div className='flex items-center text-sm gap-1 rounded-sm'>Copy ID <div className="ml-1 flex gap-1 items-center p-[1px_6px] rounded-sm bg-gray-700 text-xs font-normal">ctrl</div>+<div className="ml-1 flex gap-1 items-center p-[1px_6px] rounded-sm bg-gray-700 text-xs font-normal">i</div></div>
                    }>
                        <button className='text-xs text-[#687385] flex items-center gap-1'>123 <CopyIcon2 className="fill-[#687385]" /></button>
                    </Tooltip>
                </div>
                <div className="flex items-center justify-between mt-1 pb-3 border-b-[1px] border-[#ebeef1]">
                    <h3 className='text-[#1a1b25] sm:text-[28px] text-[22px] font-bold'>see</h3>
                    <div className="flex items-center gap-4">
                        <Menu placement="bottom-end">
                            <MenuHandler>
                                <button className='input_focus_shadow px-2 py-1 hover:bg-white rounded-md'><BsThreeDots /></button>
                            </MenuHandler>
                            <MenuList className='px-0 py-2 mt-2 min-w-[168px] outline-remove'>
                                <MenuItem onClick={handleOpenDelCoupon} className='text-sm font-medium text-[#df1b41] px-[12px] py-1 rounded-none'>Delete coupon</MenuItem>
                            </MenuList>
                        </Menu>
                    </div>
                </div>
                <div className='flex my-[20px]'>
                    <div className='pr-4 border-r-[1px] border-[#ebeef1] text-sm'>
                        <h3 className='text-[#687385]'>Terms</h3>
                        <p className='text-[#414552] mt-1'>3% off forever</p>
                    </div>
                    <div className='pl-4 border-l-[1px] border-[#ebeef1] text-sm'>
                        <div className='text-[#687385] flex items-center gap-2'>Usage</div>
                        <p className='text-[#414552] mt-1'>No redemptions yet</p>
                    </div>
                </div>
                <div className="mt-12">
                    <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                        <span className="text-[#30313d] sm:text-[20px] text-[16px] font-bold">Details</span>
                        <button onClick={handleOpenUpdateCoupon} className='h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2'><PencilIcon />Edit</button>
                    </div>
                    <div className="grid sm:grid-cols-2 grid-cols-1">
                        <div className='p-[12px_20px]'>
                            <div className='flex text-sm'>
                                <div className='text-[#687385] max-w-[200px] w-full'>ID</div>
                                <span className='text-[#414552]'>231</span>
                            </div>
                            <div className='flex text-sm mt-2'>
                                <div className='text-[#687385] max-w-[200px] w-full'>Name</div>
                                <span className='text-[#414552]'>see</span>
                            </div>
                            <div className='flex text-sm mt-2'>
                                <div className='text-[#687385] max-w-[200px] w-full'>Created</div>
                                <span className='text-[#414552]'>Jun 16</span>
                            </div>
                        </div>
                        <div className='p-[12px_20px]'>
                            <div className='flex text-sm'>
                                <div className='text-[#687385] max-w-[200px] w-full'>Valid</div>
                                <span className='text-[#414552]'>Yes</span>
                            </div>
                            <div className='flex text-sm mt-2'>
                                <div className='text-[#687385] max-w-[200px] w-full'>Percentage discount</div>
                                <span className='text-[#414552]'>3%</span>
                            </div>
                            <div className='flex text-sm mt-2'>
                                <div className='text-[#687385] max-w-[200px] w-full'>Duration</div>
                                <span className='text-[#414552]'>Forever</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-12">
                    <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                        <span className="text-[#30313d] sm:text-[20px] text-[16px] font-bold">Promotion Codes</span>
                        <button onClick={handleOpenPromoCode} className='h-[30px] rounded-[6px] w-max whitespace-nowrap input_focus_shadow sm:text-[14px] text-[12px] font-semibold p-[0_8px] flex items-center sm:gap-2 gap-1'><BiPlus className='sm:text-[20px] text-[16px]' />Add a promotion code</button>
                    </div>
                    <p className='text-center text-sm text-[#687385] font-semibold py-[48px]'>No promotion codes</p>
                </div>
                <div className="mt-12">
                    <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                        <span className="text-[#30313d] sm:text-[20px] text-[16px] font-bold">Active redemptions</span>
                    </div>
                    <div className='w-full border-b-[1px] border-[#ebeef1] flex items-center'>
                        <button className={`${tab === 'customer' ? "text-[#625afa] border-[#625afa]" : "text-[#6873785] border-transparent"} border-b-[2px] font-medium text-sm sm:p-[16px_20px] p-[12px]`} onClick={() => handleSetTab('customer')}>Customers</button>
                        <button className={`${tab === 'subs' ? "text-[#625afa] border-[#625afa]" : "text-[#6873785] border-transparent"} border-b-[2px] font-medium text-sm sm:p-[16px_20px] p-[12px]`} onClick={() => handleSetTab('subs')}>Subscriptions</button>
                    </div>
                    <div className='text-center py-[48px]'>
                        <h3 className='text-sm text-[#687385] font-semibold'>Promotion Codes</h3>
                        <p className='text-sm text-[#687385]'>No customers currently redeem this coupon</p>
                    </div>
                </div>
                <div className="mt-12">
                    <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                        <span className="text-[#30313d] sm:text-[20px] text-[16px] font-bold">Metadata</span>
                        <button onClick={handleAddMetadata} disabled={options.metaData ? true : false} className={`${options.metaData && "opacity-60 "} h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2`}><PencilIcon />Edit metadata</button>
                    </div>
                    <div className='mt-3'>
                        {options.metaData ?
                            <div>
                                <div className="w-full flex gap-3 pb-5 border-b-[1px] border-[#ebeef1]">
                                    <input type="text" placeholder="Key" className="input_focus_shadow max-w-[175px] text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                    <textarea placeholder="Value" className="input_focus_shadow py-1 text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                    <button>
                                        <AiTwotoneDelete className="text-[18px] text-[#625afa]" />
                                    </button>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <button className="sm:ml-3 flex items-center gap-1 text-sm font-semibold text-[#625afa]"><BiPlus className='text-[18px]' /> Add custom field</button>
                                    <div className="font-semibold sm:p-[16px_20px] p-[16px_0_16px_0] flex text-base text-gray-900 gap-2">
                                        <button onClick={handleAddMetadata} className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px]">Cancel</button>
                                        <button className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Save</button>
                                    </div>
                                </div>
                            </div> :
                            <p className='text-sm text-[#a3acba]'>No metadata</p>
                        }
                    </div>
                </div>
                <div className="mt-12">
                    <div>
                        <div className="flex justify-between py-[12px]">
                            <span className="text-[#1a1b25] sm:text-[20px] text-[16px] font-bold">Logs</span>
                        </div>
                        <div>
                            <div className='w-full overflow-x-auto'>
                                <div className="flex justify-between sm:w-full w-[610px] border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                    <div className="flex items-center gap-6">
                                        <div className="bg-[#ebeef1] text-[#545969] p-[1px_6px] rounded-[4px] text-xs font-semibold">200 OK</div>
                                        <div>
                                            <code className="text-[13px] text-[#585969]">POST /v1/products/prod_O2NtrSnO6Tpf91</code>
                                        </div>
                                    </div>
                                    <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-12">
                    <div>
                        <div className="flex justify-between py-[12px]">
                            <span className="text-[#1a1b25] sm:text-[20px] text-[16px] font-bold">Events</span>
                        </div>
                        <div>
                            <div className='w-full overflow-x-auto'>
                                <div className="flex justify-between sm:w-full w-[610px] border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                    <div className="flex items-center gap-6">
                                        <div>
                                            <span className="text-[13px] text-[#585969]">A product with ID prod_O2NtrSnO6Tpf91 was updated</span>
                                        </div>
                                    </div>
                                    <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DeleteCouponModal delCoupon={delCoupon} setDelCoupon={setDelCoupon} />
            <UpdateCouponDetailModal active={active} setActive={setActive} />
            <AddPromoCodeModal promoCode={promoCode} setPromoCode={setPromoCode} />
        </div>
    )
}

export default CouponDetails